import { render, staticRenderFns } from "./LabelsComboBox.vue?vue&type=template&id=0c03b136&scoped=true&"
import script from "./LabelsComboBox.vue?vue&type=script&lang=js&"
export * from "./LabelsComboBox.vue?vue&type=script&lang=js&"
import style0 from "./LabelsComboBox.vue?vue&type=style&index=0&id=0c03b136&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c03b136",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VChip,VCombobox,VListItem,VListItemContent,VListItemTitle,VSubheader})
